<template>
  <div class="content self_intergral_recode self_c">
    <headNav
      :color="window_.color"
      :back="true"
      :options="option1"
      :value_="value_"
      :selectChange="selectChange"
    />
    <div class="self_b">
      <van-pull-refresh
        v-model="refreshData.isLoading"
        @refresh="onRefresh"
        :pulling-text="refreshData.pullingText"
        :loosing-text="refreshData.loosingText"
        :loading-text="refreshData.loadingText"
        :success-text="refreshData.successText"
        v-bind:style="'min-height:' + boxWh + 'px;'"
      >
        <van-list
          @load="onDownRefresh"
          v-model="refreshUpData.isLoading"
          :finished="refreshUpData.upFinished"
          :finished-text="refreshUpData.finishedText"
          :loading-text="refreshData.loadingText"
        >
          <div style="background-color: #FFF; ">
            <div
              class="int_recode-item"
              v-for="(item, index) in recodeData"
              :key="index"
            >
              <img
                v-if="errorImg(item.restaurantImg)"
                class="int_recode-item_img"
                :src="item.restaurantImg"
              />
              <img
                v-else
                class="int_recode-item_img"
                src="../../assets/icon/small_default.png"
              />
              <div class="int_recode-item_content">
                <div class="int_recode-item_c_title ttt">
                  <div :style="'color:' + window_.color + ';'">{{ item.shopname }}</div>
                  <div class="int_recode-item_c_title-n">
                    {{ item.pointsAdd - item.pointsUse > 0 ? '+' + (item.pointsAdd - item.pointsUse) : item.pointsAdd - item.pointsUse }}
                  </div>
                </div>
                <div class="int_recode-item_c_title">
                  <div class="font_B">{{ window_c['Total Bill'] }}：</div>
                  <div class="font_C">{{ item.billamount }}</div>
                </div>
                <div class="int_recode-item_c_title">
                  <div class="font_B">{{ window_c['Coupon'] }}：</div>
                  <div class="font_D">{{ item.pointsUse }}</div>
                </div>
                <div class="int_recode-item_c_title">
                  <div class="font_B">{{ window_c['Eam point'] }}：</div>
                  <div class="font_C">{{ item.pointsAdd }}</div>
                </div>
                <div
                  v-show="item.billno"
                  class="int_recode-item_c_title"
                >
                  <div>{{ window_c['Reference no'] }}：</div>
                  <div>{{ item.billno }}</div>
                </div>
                <div
                  v-show="item.createDate"
                  class="int_recode-item_c_title"
                >
                  <div>{{ window_c['Date'] }}：</div>
                  <div>{{ item.createDate }}</div>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import headNav from '@/components/headNavx';
import {
  pointDetails
} from '@/js/api';
import util from '@/js/util.js';
import lang_ from '@/js/locales';
export default {
  data () {
    return {
      window_c: {
        'Total Bill': '總金額',
        Coupon: '使用',
        'Eam point': '獲得',
        Date: '時間',
        'Reference no': '單號'
      },
      boxWh: window.innerHeight - 46,
      value_: 0,
      option1: [{
        text: '所有積分記錄',
        value: 0
      }, {
        text: '使用積分記錄',
        value: 1
      }, {
        text: '獲得積分記錄',
        value: 2
      }],
      window_: {
        color: '#56AC9A',
        de_img: '../../assets/icon/small_default.png'
      },
      refreshData: {
        isLoading: false,
        count: 0,
        pullingText: '下拉既可刷新...',
        loosingText: '釋放立即刷新...',
        loadingText: '加載中...',
        successText: '刷新成功'
      },
      refreshUpData: {
        isLoading: true,
        upFinished: false,
        finishedText: '沒有更多數據了...'
      },
      recodeData: [],
      inrecodeParams: {
        memberId: 0,
        brandId: 0,
        type: 1,
        flag: 0, // 2 表示所有積分 1 表示使用積分 0表示獲得積分
        pageIndex: 1,
        pageSize: 10
      }
    };
  },
  created () {
    util.selfSetIcon(); // 設置logo
    util.getBrand(this, () => {
      this.window_.color = this.themeColor;
      this.inrecodeParams.brandId = util.getBrandId(this);
      this.initPointDetails('down');
    })
    this.init_lang();
    this.initWindow();
  },
  mounted () { },
  methods: {
    init_lang () {
      var window_c = this.window_c;
      this.refreshData['pullingText'] = lang_.t('Drop down to refresh');
      this.refreshData['loosingText'] = lang_.t('Release refresh now');
      this.refreshData['successText'] = lang_.t('Refresh success');
      this.refreshData['loadingText'] = lang_.t('Loading');
      this.refreshUpData['finishedText'] = lang_.t('No more data');
      window_c['Total Bill'] = lang_.t('Total Bill');
      window_c['Coupon'] = lang_.t('Coupon');
      window_c['Eam point'] = lang_.t('Eam point');
      window_c['Date'] = lang_.t('Date');
      window_c['Reference no'] = lang_.t('Reference no');
      this.option1[0].text = lang_.t('All points record');
      this.option1[1].text = lang_.t('Use points record');
      this.option1[2].text = lang_.t('Get points record');
    },
    initWindow () {
      let userinfo = util.userInfo.get(this);
      if (userinfo) {
        var userInfo = JSON.parse(userinfo);
        this.inrecodeParams.memberId = userInfo.memberId;
      }
    },
    selectChange (e) {
      this.inrecodeParams.flag = e;
      this.refreshUpData.upFinished = false;
      this.initPointDetails('down');
    },
    onRefresh () {
      this.refreshUpData.upFinished = false;
      this.initPointDetails('down');
    },
    onDownRefresh () {
      this.inrecodeParams.pageIndex += 1;
      this.initPointDetails('up');
    },
    initPointDetails (e) {
      var self = this;
      if (e == 'down') {
        self.inrecodeParams.pageIndex = 1;
      }
      const toast = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: self.refreshData['loadingText']
      });
      pointDetails(self.inrecodeParams).then(res => {
        if (res.code == '1') {
          self.$toast.clear();
          self.refreshData.isLoading = false;
          if (res.data.data.length == 0) {
            this.refreshUpData.isLoading = false;
            this.refreshUpData.upFinished = true;
          } else {
            this.refreshUpData.isLoading = false;
          }
          if (e == 'down') {
            self.recodeData = res.data.data;
          } else {
            self.recodeData = self.recodeData.concat(res.data.data);
          }
        }
      });
    },
    errorImg (img) {
      return util.errorImg(img);
    }
  },
  components: {
    headNav
  }
};
</script>

<style scoped>
.int_recode-item {
  /* height: 50px; */
  display: flex;
  padding: 20px;
  position: relative;
}
.content {
  padding-top: 46px;
}

.int_recode-item:after {
  position: absolute;
  content: "";
  height: 1px;
  left: 0;
  right: 0;
  bottom: 0;
  transform: scaleY(0.5);
  background-color: rgb(245, 245, 245);
}

.int_recode-item_img {
  width: 100px;
  height: 100px;
}

.int_recode-item_content {
  width: calc(100% - 100px);
  display: flex;
  flex-direction: column;
}

.ttt div:first-child {
  width: calc(100% - 40px);
  word-break: break-all;
  font-size: 16px;
  font-weight: 600;
}
.ttt div:last-child {
  width: 40px;
  text-align: right;
}
.int_recode-item_c_title {
  display: flex;
  align-items: baseline;
  padding: 5px;
}

.int_recode-item_c_title-n {
  margin-left: auto;
  color: rgb(229, 155, 82);
  font-weight: 600;
}

.font_B {
  font-weight: 600;
}

.font_C {
  color: rgb(229, 155, 82);
}

.font_D {
  color: rgb(227, 56, 44);
  font-weight: 600;
}

.int_recode-item_c_title div:first-child {
  min-width: 50px;
}

.int_recode-item_c_title div:last-child {
  flex-grow: 1;
}
</style>



// WEBPACK FOOTER //
// src/view/integral/integral_recode.vue